
    import '/opt/buildhome/repo/components/overview/index.en-US.md?watch=parent';
    export const demoIndex = {
  ids: [],
  getter: () => import(/* webpackChunkName: "meta__components__en-US" */'/opt/buildhome/repo/components/overview/index.en-US.md?type=demo')
};